import React from 'react';
import { Link } from 'react-router-dom';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
//components
import LogoutButton from '../components/logoutbutton/LogoutButton';
import ProgressBar from '../components/progress-bar/ProgressBar';
//styles
import 'bootstrap/dist/css/bootstrap.css';
import './dashboard.styl';
import '../../ext/font-awesome-4.7.0/css/font-awesome.css';
//text
import { dashboard, Categories, stats, account } from '../input-text/en/dashboard';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: this.props.user.firstName,
      api_key: this.props.user.key,
      call_count: this.props.user.hits,
      call_limit: this.props.user.monthlyHitsLimit,
      reset_date: this.props.user.resetDate,
      resetWindow: null,
      deactivateWindow: null,
    };
  }

  componentWillReceiveProps = () => {
    if(this.props.children){
      this.setState({ resetWindow: this.props.children[0] });
      this.setState({ deactivateWindow: this.props.children[1] });
    }
  }

  render = () => {
    return (
      <div className='dashboard profile-page-outer-container'>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-md-4 hidden-xs header-image-container'>
            <i className="fa fa-user-circle-o fa-5x developers-icon" aria-hidden="true"></i>
          </div>
          <div className='col-xs-12 col-md-8 header-info'>
            <h1>{this.state.name+dashboard._1}</h1>
            <p>{dashboard._2}<span className='highlight'>{this.state.name}</span>{dashboard._3}</p>
          </div>
        </SimpleContainer>
        <SimpleContainer color='white' containerClass='padded-container category-wrapper-substitute'>
          <div>
            <div className='col-xs-6 col-md-4 dash-title'>
              <h1>{dashboard._4}</h1><br/>
            </div>
            <div className='dash-key col-xs-12 col-md-8'>
              <div className="form-group">
                <p>{dashboard._6}<a className='highlight-link' href="http://aircheckr.com/api_docs" target="_blank"> in our API documentation</a></p>
                <textarea className="api-key-container form-control highlight" rows="2" value={this.state.api_key} readOnly/>
              </div>
            </div>
          </div>
        </SimpleContainer>
        <SimpleContainer color='white' containerClass='padded-container category-wrapper-substitute'>
          <div className='col-xs-12 col-md-4 dash-hits'>
            <h1>{stats._1}</h1>
          </div>
          <div className='col-xs-12 col-md-8 dash-count'>
            <p className="dashboard__monthly-usage">
              <span>{stats._3}<strong>{this.state.call_count}</strong>&nbsp;
                <small>
                  ({(Math.floor((this.state.call_count/this.state.call_limit)*100) !== (this.state.call_count/this.state.call_limit)*100) ? '≅' : ''} 
                  {Math.floor((this.state.call_count/this.state.call_limit)*100)}%&nbsp; 
                  {stats._4})
                </small>
              </span>
              <br/>
              <span>{stats._5}<strong>{new Date(this.state.reset_date).toLocaleDateString('en-US', {
                year: 'numeric', month: 'long', day: 'numeric'
              })}</strong></span>
            </p>
            <ProgressBar 
              min={0} 
              max={this.state.call_limit} 
              value={this.state.call_count} 
            />
          </div>
        </SimpleContainer>
        <SimpleContainer color='white' containerClass='padded-container category-wrapper-substitute'>
          <div className='col-xs-12 col-md-4 dash-hits'>
            <h1>{Categories._2.title}</h1>
          </div>
          <div className='col-xs-12 col-md-8 dash-count'>
            <p dangerouslySetInnerHTML={{ __html: Categories._2.subcategories[0].text }}></p>
          </div>
        </SimpleContainer>
        <SimpleContainer color='white' containerClass='padded-container category-wrapper-substitute'>
          <div className='col-xs-12 col-md-4'>
            <h1>{account._1}</h1>
          </div>
          <div className='col-xs-12 col-md-8 dash-account'>
            <Link to='/dashboard/resetpass' className='btn btn-warning'>Reset password</Link>&nbsp;&nbsp;
            <LogoutButton />
          </div>
        </SimpleContainer>
          {this.state.resetWindow}
        <SimpleContainer color='white' containerClass='padded-container category-wrapper-substitute'>
          <div className='col-xs-12 col-md-4'>{/*empty to format space correctly*/}</div>
          <div className='col-xs-12 col-md-8 dash-account'>
            <p dangerouslySetInnerHTML={{ __html: account._5 }}></p>
            <br/>
          </div>
        </SimpleContainer>
          {this.state.deactivateWindow}
      </div>
    );
  }
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/routes/Dashboard.js